<template>
<div>
    <base-header v-once pageName="기존 리크루팅 조회" :popup="true"></base-header>
    
    <section id="wrap">
        <div class="recuInfo">
            <p>기존 리크루팅이 총 <em>{{tot}}</em>건이 있습니다.</p>
            <ul>
                <li v-for="(recruitInfo, index) in recruitInfoList" :key="index"><strong>{{recruitInfo.cntrNm}}센터</strong> <span>{{recruitInfo.regDate}}</span></li>
                <!-- 검색 결과 실패시-->
                <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="InfiniteLoading">
                <div slot="no-more"></div>
                <div slot="no-results">
                    <div class="search-resutl-None">
                        <p>내용이 없습니다.</p>
                    </div> 
                </div>
                </infinite-loading>
            </ul>
        </div>
    </section> 
    <div class="btnWrap">
        <button type="button" class="red" @click="close()">확인</button>
    </div>
</div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
export default {
  components: {
    InfiniteLoading
  },
  data() {
      return{
            searchCustNm: "",
            tel1: "",
            tel2: "",
            tel3: "",
            tot:0,
            offset: 0,	 //현재 가지고있는 갯수
            size : 10,	//한번에 가져오는 수
            recruitInfoList: [],
      };
  },
  methods: {
    infiniteHandler: function($state) {
      var that = this;
      var parameters = {
        searchCustNm: this.searchCustNm,
        tel1: this.tel1,
        tel2: this.tel2,
        tel3: this.tel3,
        offset: this.offset,
        size: this.size
      };
      this.$api.myCstmr.getRecruitInfoList(parameters)
        .then(function(res) {            
        console.log("getRecruitInfoList res", res);
          that.tot = res.totCnt;
          var list = res.recruitInfoList;
          if (list.length) {
            that.offset += that.size;
            that.recruitInfoList = that.recruitInfoList.concat(list);
            $state.loaded();
            if (list.length < that.size) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    getRecruitInfoList() { // 전화번호에 대한 구매이력조회
        this.tot = 0;
        this.offset = 0
        this.size = 10
        this.recruitInfoList = [];
        this.$refs.InfiniteLoading.stateChanger.reset();
    },
    close: function(){
        window.app.$root.$utils.nativeIf.outbound.close(false);
    }
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
    var parent = this.$store.getters.parent;
        if(parent.name == 'recruit-pop-param'){  // 부모창에서 받은 정보.
            console.log("RecruitInfo.vue mounted this.$store.getters.parent.data", parent.data);
            this.searchCustNm = parent.data.searchCustNm;
            this.tel1 = parent.data.tel1;
            this.tel2 = parent.data.tel2;
            this.tel3 = parent.data.tel3;
            
            // 넘어온 파라메터 초기화
            parent = {
                name: 'recruit-pop-param',
                data: {
                  searchCustNm:""
                  ,tel1:""
                  ,tel2:""
                  ,tel3:""
                }
            };
            this.$store.commit("SET_UI_PARENT", parent);

            this.getRecruitInfoList();
        }
  }
}
</script>
